module.exports = __webpack_public_path__ + "img/重庆电力.f2b41270.png";